import CheckCircle from "@mui/icons-material/CheckCircle";
import NoAccounts from "@mui/icons-material/NoAccounts";
import People from "@mui/icons-material/People";
import MUIBottomNavigation from "@mui/material/BottomNavigation";
import MUIBottomNavigationAction from "@mui/material/BottomNavigationAction";
import Chip from "@mui/material/Chip";
import { colors } from "healthex-common/colors";
import * as React from "react";
import styled, { css } from "styled-components";
import { mobilePageMaxWidth } from "./HXMobilePage.styles";
import Home from "@mui/icons-material/Home";
import Group from "@mui/icons-material/Group";
const footerHeight = 62;
const footerTopMargin = 16;
export const FixedFooterNavigationContainer = styled.div `
    position: relative;
    padding-bottom: ${footerHeight + footerTopMargin}px;
`;
export const FixedFooterNavigation = styled(MUIBottomNavigation) `
    position: fixed;
    width: 100%;
    max-width: ${mobilePageMaxWidth}px;
    bottom: 0;
    left: auto;
    right: auto;
    height: ${footerHeight}px;
    border-top: 1px solid ${colors.black_12};
    background: ${colors.white_main};
    z-index: 1;
    justify-content: space-evenly;
`;
export const FixedFooterNavigationAction = styled(MUIBottomNavigationAction) `
    color: ${colors.black_30};
    .Mui-selected {
        color: ${colors.navy_main};
    }
`;
const CheckCircleIcon = styled(CheckCircle) `
    color: ${colors.chips_ember} !important;
`;
const PeopleIcon = styled(People) `
    color: ${colors.chips_azure} !important;
`;
const NoAccountsIcon = styled(NoAccounts) `
    color: ${colors.chips_amethyst} !important;
`;
const BaseChip = styled(Chip).attrs({ variant: "outlined", size: "small" }) ``;
export const PrescreenChip = styled(BaseChip).attrs({
    icon: React.createElement(CheckCircleIcon),
}) `
    color: ${colors.chips_ember};
    border-color: ${colors.chips_ember};
`;
export const EnrollmentChip = styled(BaseChip).attrs({
    icon: React.createElement(PeopleIcon),
}) `
    color: ${colors.chips_azure};
    border-color: ${colors.chips_azure};
`;
export const DeidentifiedChip = styled(BaseChip).attrs({
    icon: React.createElement(NoAccountsIcon),
}) `
    color: ${colors.chips_amethyst};
    border-color: ${colors.chips_amethyst};
`;
const BaseIcon = css `
    width: 24px;
    height: 24px;
`;
export const HomeIcon = styled(Home) `
    ${BaseIcon}
`;
export const GroupIcon = styled(Group) `
    ${BaseIcon}
`;
